import config from '../config/config';
import { getS3Url } from '../utils/s3Utils';

export const fetchGalleryFolders = async () => {
    try {
        const response = await fetch(`${config.apiUrl}/api/gallery/folders`);
        if (!response.ok) throw new Error('Failed to fetch folders');
        const data = await response.json();
        console.log('Fetched folders:', data);
        return data;
    } catch (error) {
        console.error('Error fetching folders:', error);
        throw error;
    }
};

export const fetchFolderContents = async (folderName) => {
    try {
        const response = await fetch(`${config.apiUrl}/api/gallery/folders/${encodeURIComponent(folderName)}`);
        if (!response.ok) throw new Error('Failed to fetch folder contents');
        const data = await response.json();
        console.log('Fetched folder contents:', data);

        // Transform the data to include full URLs
        const files = data.files.map(file => ({
            ...file,
            originalPath: `${config.mediaBaseUrl}/${file.originalKey}`,
            thumbnailPath: `${config.mediaBaseUrl}/${file.thumbnailKey}`
        }));

        return files;
    } catch (error) {
        console.error('Error fetching folder contents:', error);
        throw error;
    }
};